import React, { PropsWithChildren } from 'react'
import { Tooltip } from '@node-space/ui-components'

export interface InfoTooltipProps extends PropsWithChildren {
  isSimple?: boolean
}

export const InfoTooltip = ({ isSimple, children }: InfoTooltipProps) => {
  return <Tooltip bodyContent={children} type={isSimple ? 'simple' : 'complex'} />
}
